<template>
  <BranchApp />
</template>

<script>
import BranchApp from "../../components/BranchApp/BranchApp.vue";

export default {
  name: "app",
  components: {
    BranchApp
  }
};
</script>
